module.exports = __webpack_public_path__ + "media/images/lp_v6_sec12_sp-e9a9aa6ddc9fab995a27d98e0f5d47cb.png";